import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Controller from '@ember/controller';

/**
 * Controller for the Reset Email form in settings.
 */
class ResetEmailController extends Controller {
  @service session;
  @service api;

  @action
  resetEmail(jsonData) {
    return this.api.post(`users/${this.session.currentUser.id}/email/reset`, {
      jsonData,
    });
  }
}

export default ResetEmailController;
